import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import alum1 from './pictures/alum1.jpg';
import alum2 from './pictures/alum2.jpg';
import alum3 from './pictures/alum3.jpg';

const Alumni = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Alumni Networking Picnic!</h2>
                    <p class="site-post-meta">May 21, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    <br></br>
                    <br></br>
    
                    Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you to everyone who joined us for our recent Alumni Networking event at Rainier Vista! We had a wonderful time connecting with alumni under the sunshine, enjoying good conversations and tasty snacks.


                    <br></br>
                    <br></br>

The highlight of the event was our inspiring alumni panel featuring women professionals from the University of Washington who are now working across various companies in the tech industry. They generously shared their career journeys, the challenges they’ve overcome, and the insights they’ve gained along the way. From navigating the workplace to embracing growth in the tech world, their stories were both eye-opening and encouraging.

                    <br></br>
                    <br></br>

We’re so grateful to Alison, Audrey, and Savanna for speaking with us and offering such thoughtful advice. It was a unique opportunity to ask questions, explore different career paths, and imagine what a future in tech could look like.


                    </p>
                    <img src={alum1} alt="alum1 "/>
                    <img src={alum2} alt="alum2"/>
                    <img src={alum3} alt="alum3"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Alumni;
